import ApplicationController from "./application_controller"

const LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_LOCAL_STORAGE_KEY = "lexiqamusTextScale"
const LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS = [0.875, 1, 1.125, 1.25, 1.5]
const LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER = 1

function nearestAllowedTextScale(value) {
  const parsedTextScale = parseFloat(value)
  if (!Number.isFinite(parsedTextScale)) return LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER
  return LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS.find(
    (multiplier) => Math.abs(multiplier - parsedTextScale) < 0.001
  ) || LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER
}

// LexiQamus accessibility toolbar: large-print text scaling via CSS variable (--lq-text-scale).
export default class extends ApplicationController {
  static targets = ["decreaseTextButton", "resetTextButton", "increaseTextButton"]

  connect() {
    this.textScale = LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER
    this.restoreTextScale()
  }

  restoreTextScale() {
    let scale = LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER
    try {
      scale = nearestAllowedTextScale(window.localStorage.getItem(LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_LOCAL_STORAGE_KEY))
    } catch (_e) {
      // ignore localStorage errors (private browsing, quota exceeded)
    }
    this.setLargePrintTextScale(scale, scale !== LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER)
  }

  decreaseTextSize() {
    const currentMultiplierIndex = LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS.indexOf(this.textScale)
    if (currentMultiplierIndex > 0) {
      this.setLargePrintTextScale(LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS[currentMultiplierIndex - 1])
    }
  }

  increaseTextSize() {
    const currentMultiplierIndex = LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS.indexOf(this.textScale)
    const lastMultiplierIndex = LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS.length - 1
    if (currentMultiplierIndex >= 0 && currentMultiplierIndex < lastMultiplierIndex) {
      this.setLargePrintTextScale(LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS[currentMultiplierIndex + 1])
    }
  }

  resetTextSize() {
    this.setLargePrintTextScale(LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER)
  }

  setLargePrintTextScale(scale, notifyLayout = true) {
    this.textScale = nearestAllowedTextScale(scale)
    document.documentElement.style.setProperty("--lq-text-scale", String(this.textScale))
    this.updateTextSizeToolbarButtonStates()

    try {
      window.localStorage.setItem(LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_LOCAL_STORAGE_KEY, String(this.textScale))
    } catch (_e) {
      // ignore localStorage errors (private browsing, quota exceeded)
    }
    if (notifyLayout) window.dispatchEvent(new Event("resize"))
  }

  updateTextSizeToolbarButtonStates() {
    if (this.hasDecreaseTextButtonTarget) {
      this.decreaseTextButtonTarget.disabled = this.textScale <= LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS[0]
    }
    if (this.hasIncreaseTextButtonTarget) {
      const largestTextScaleMultiplier = LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS[
        LEXIQAMUS_ACCESSIBILITY_TEXT_SCALE_MULTIPLIERS.length - 1
      ]
      this.increaseTextButtonTarget.disabled = this.textScale >= largestTextScaleMultiplier
    }
    if (this.hasResetTextButtonTarget) {
      this.resetTextButtonTarget.setAttribute(
        "aria-pressed",
        this.textScale === LEXIQAMUS_ACCESSIBILITY_DEFAULT_TEXT_SCALE_MULTIPLIER ? "true" : "false"
      )
    }
  }
}
